module.exports = __webpack_public_path__ + "images/fifth_anniversary/step1-number-icon_605d29569cdf06db90e60704ad56a6ad.png";